import cryptoUtil from '@/utils/crypto.js'
import JSEncrypt from 'jsencrypt'
const Qs = require('qs')

const ENCRYPTION_TYPE = {
  PARAMS_ONLY: 1,
  FORM_DATA: 2,
  JSON_BODY: 3
}
// 请求时参数不加密的url
const whiteList = [
  '/common/**',
  '/api/**',
  '/picupload',
  '/user/login',
  '/user/register',
  '/server/proplist',
  '/server/acttype',
  '/user/changepwd',
  '/user/applyAgent',
  '/user/order/changeStatus',
  '/server/exception/notice',
  '/system/agency/protocol/**',
  '/user/order/callback/**'
]

//  检查 URL 是否匹配配置列表中的模式
// Cache compiled regex patterns
function shouldSkipEncryption(url) {
  return whiteList.some((pattern) => {
    if (pattern.includes('**')) {
      // 取 ** 前缀部分
      const prefix = pattern.split('**')[0]
      return url.startsWith(prefix)
    } else {
      return url === pattern
    }
  })
}
function encryptTranPwd(passwd) {
  const jse = new JSEncrypt()
  const publicKey =
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDDgTt/niY5uJrxHZ0JkPSDgYljqPgBtFkUoyUel5kEt2gxIAjcFy1Qehu+aLUUkdbWqaJDpugabJeLldyTc7zz5jD8i24tEOi+2XH5XvP6uBnIUQA65cGMkiAjEWHz/4UPCzgaDN7iAweMljAFfSOlXw3Vgd/py4MP30oXNxEQXQIDAQAB'
  // 设置公钥
  jse.setPublicKey(localStorage.getItem('publicKey') || publicKey)
  return jse.encrypt(passwd)
}
function getQuery(url) {
  const q = {}
  if (url && typeof url === 'string') {
    const query = url.split('?')[1]
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      q[pair[0]] = decodeURIComponent(pair[1])
    }
  }
  return q
}

function encryptMsg(config, sid, type) {
  try {
    if (process.env.VUE_APP_DEBUG === 'true') {
      console.groupCollapsed(`${config.method}: ${config.url.split('?')?.[0]}`) // Collapsible group header
      console.log('Params/Data:', config.params || config.data) // Separate line for parameters/data
      console.log('config info:', config) // Separate line for URL
      console.groupEnd() // End of group
    }

    let params = ''
    if (type === ENCRYPTION_TYPE.PARAMS_ONLY) {
      params = config.params ? Qs.stringify(config.params) : ''
    } else if (type === ENCRYPTION_TYPE.FORM_DATA) {
      params = Qs.stringify(JSON.parse(JSON.stringify(config.data)), { arrayFormat: 'repeat' })
    } else {
      params = JSON.parse(JSON.stringify(config.data))
    }
    const timestamp = new Date().getTime()
    const nonce = cryptoUtil.randomResult(16)
    const fundKey = cryptoUtil.randomResult(32)
    const payload = {
      nonce,
      sid,
      timestamp
    }
    if ([ENCRYPTION_TYPE.PARAMS_ONLY, ENCRYPTION_TYPE.FORM_DATA].includes(type)) {
      payload.msg_params = params
    } else {
      payload.params = ''
    }
    const signature = cryptoUtil.sha512Encrypt(cryptoUtil.sortParams(payload))
    const msg_encrypt = cryptoUtil.aesEncrypt(
      Qs.stringify({
        ...payload,
        signature
      }),
      fundKey
    )
    const body_encrypt = params ? cryptoUtil.aesEncrypt(JSON.stringify(params), fundKey) : ''
    if ([ENCRYPTION_TYPE.PARAMS_ONLY, ENCRYPTION_TYPE.JSON_BODY].includes(type)) {
      config.url += `?msg_encrypt=${msg_encrypt}`
    }

    config.data =
      type === ENCRYPTION_TYPE.PARAMS_ONLY
        ? null
        : type === ENCRYPTION_TYPE.FORM_DATA
        ? { msg_encrypt }
        : { body_encrypt }
    config.params = null
    config.headers['fundKey'] = encryptTranPwd(fundKey)
    config.headers['sid'] = sid
  } catch (e) {
    console.error('加密失败', e)
  }
}
export function assembleConfig(config) {
  if (!shouldSkipEncryption(config.url)) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const sid = userInfo?.userId || ''
    // 没有params和data但是通过?传参数的url 处理成params
    if (config.url.indexOf('?') !== -1) {
      const p = getQuery(config.url)
      if (config.params) {
        for (const key in p) {
          if (Object.prototype.hasOwnProperty.call(p, key)) {
            config.params[key] = p[key]
          }
        }
      } else {
        config.params = p
      }
      config.url = config.url.split('?')[0]
    }
    // 通过?传参数的url 或者者没有params和data的url
    if (config.params || (!config.params && !config.data)) {
      encryptMsg(config, sid, ENCRYPTION_TYPE.PARAMS_ONLY)
      return
    }
    if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      encryptMsg(config, sid, ENCRYPTION_TYPE.FORM_DATA)
      return
    }
    if (config.data && config.headers['Content-Type'] !== 'application/x-www-form-urlencoded') {
      encryptMsg(config, sid, ENCRYPTION_TYPE.JSON_BODY)
      return
    }
  }
}
